var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"message"}},[_c('top'),_c('div',{staticClass:"mian",style:({ height: _vm.mianH + 'px' })},[_c('div',{staticClass:"apart_list"},[_c('ChapterOutlineImport')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }